import moment from 'moment';
import CacheableDataObject from './CacheableDataObject';
import PlaidBankAccount from "./PlaidBankAccount.js";
import Transaction from "./Transaction.jsx";
import TransactionRenderKey from "../utilities/TransactionRenderKey.jsx";

export default class PlaidTransaction extends CacheableDataObject {
	beforeConstruct() {
		this.typeof = 'PlaidTransaction';
	}

	getRenderKey() {
		return TransactionRenderKey.getKey(this, {
			[TransactionRenderKey.TYPE_PLAID]: true,
		});
	}

	getPlaidTransaction() {
		return this;
	}

	isSetToAnExpenseCategory() {
		return this.amount >= 0;
	}

	createTransaction() {
		return Transaction.create({
			id: null,
			category_id: undefined,
			amount: this.amount,
			where: this.name,
			transaction_date: this.date,
			plaid_transaction_id: this.plaid_transaction_id,
		});
	}

	isBankTransaction() {
		return true;
	}

	isSplit() {
		return false;
	}

	isComplete() {
		return true;
	}

	get where() {
		return this.name;
	}

	get transaction_date() {
		return this.date;
	}
}

PlaidTransaction.prototype.dataLocationParsers = {
	date: (transaction, data) => {
		if(data.date) {
			if(moment.isMoment(data.date)) {
				transaction.date = data.date.clone();
			} else {
				transaction.date = moment.unix(data.date);
			}

			transaction.month = transaction.date.month();
			transaction.year = transaction.date.year();
		}
	},
	account: function(transaction, data) {
		if(data.account._id) {
			transaction.account = PlaidBankAccount.retrieve({ id: data.account._id });
		} else {
			transaction.account = PlaidBankAccount.retrieve(data.account);
		}
	}
};